import React, { useState } from "react";
import "./modal.css";
import Button from "@mui/material/Button";
import { Box } from "@mui/system";
import { CircularProgress, IconButton, Typography } from "@mui/material";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import { styles } from "./styles";
import { ShowErrorToast } from "../../Common/Toast/toast";
import { httpsCallable } from "firebase/functions";
import {
  StyledTextField
} from '../../../Infrastructure/Theme/styledComponents';
import { functions } from "../../../Infrastructure/config";
import { useSelector } from "react-redux";

const EmailModal = ({ open, setOpen, coursesModal }) => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false)
  const ip = useSelector((state) => state.ip.address)
  const page = useSelector((state)=> state.route.currentRoute)

  const handleEmailChange = (event) => {
    setEmail(event.target.value)
    if (event.target.value) {
      setError("")
    }
  };

  const handleClose = () => {
    setOpen(false);
    setLoading(false)
    setError("");
  }

  const handleJoinClick = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) {
      setError("Email is required");
      return;
    }
    if (!emailRegex.test(email)) {
      setError("Please enter a valid email address.");
      return;
    }
    try {
      setLoading(true)
      const updateWaitList = httpsCallable(functions, "updatewaitlist");
      await updateWaitList({ email, ip, page });
      setOpen(false)
      setEmail("")
    } catch (error) {
      ShowErrorToast("Something went wrong. Please try again later.")
    } finally {
      setLoading(false)
    }
  }
  return (
    <>
      <Modal
        justifycontent="center"
        keepMounted
        open={open}
        onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
        disableScrollLock
      >
        <Box
          sx={
            coursesModal
              ? styles.styleCoursesScreenModal
              : styles.styleWelcomeBoxModal
          }
        >
          <IconButton
              onClick={handleClose}
              sx={{ position: 'absolute', top: 8, right: 8 }}
            >
              <CloseIcon />
            </IconButton>
            <Typography
              display="flex"
              justifycontent="center"
              alignItems="center"
              id="keep-mounted-modal-title"
              variant="h5"
              component="h2"
              sx={styles.typoHeading}
            >
              Join Waitlist
            </Typography>
          <Box
            sx={{...styles.input, flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'center'}}
            component="form"
            noValidate
            autoComplete="off"
            onSubmit={(e) => {
              e.preventDefault();
              handleJoinClick();
            }}
          >
            <StyledTextField
              className="m-4"
              display="flex"
              justifycontent="center"
              id="standard-basic"
              label={ error ? error : "Email" }
              value={email}
              onChange={handleEmailChange}
              sx={{ width: "80%" }}
              error={!!error}
              variant="standard"
            />
            {
              loading ? <CircularProgress/>
                :
                <Button
                  className="btn-width mt-4"
                  variant="contained"
                  type="submit"
                  style={{ textTransform: "capitalize", width: "180px" }}
                >
                  Join
                </Button>
            }
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default EmailModal;
